module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pt88': _vm.top_show
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.top_show) ? _c('top-fixed', {
    attrs: {
      "isback": _vm.top_isback,
      "title": _vm.top_title,
      "showRight": _vm.rightBtn
    },
    on: {
      "update:isback": function($event) {
        _vm.top_isback = $event
      },
      "update:title": function($event) {
        _vm.top_title = $event
      },
      "update:showRight": function($event) {
        _vm.rightBtn = $event
      },
      "update:show-right": function($event) {
        _vm.rightBtn = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_subscribe == 0),
      expression: "is_subscribe == 0"
    }],
    staticClass: "top-prompt",
    on: {
      "click": _vm.showQRcode
    }
  }, [_c('i', {
    staticClass: "pull-left ionicons ion-ios-information mr10"
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left"
  }, [_vm._v("您还没关注公众号，快来关注我吧！")]), _vm._v(" "), _c('button', [_vm._v("关注")])]), _vm._v(" "), _c('router-view', {
    class: {
      'none-subscribe': _vm.is_subscribe == 0
    },
    attrs: {
      "foot_type": _vm.foot_type
    }
  }), _vm._v(" "), (_vm.wrap) ? _c('div', {
    staticClass: "wrap",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "QR-code"
  }, [_c('i', {
    staticClass: "close ionicons ion-ios-close-outline",
    on: {
      "click": _vm.showQRcode
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": _vm.img_path,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("长按二维码，关注我们")])])]) : _vm._e(), _vm._v(" "), (_vm.show_kefu) ? _c('div', {
    staticClass: "h-navi",
    attrs: {
      "i": "navigation",
      "id": "moveDiv"
    },
    on: {
      "mousedown": function($event) {
        return _vm.down()
      },
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.down()
      },
      "mousemove": function($event) {
        return _vm.move()
      },
      "touchmove": function($event) {
        $event.preventDefault();
        return _vm.move()
      },
      "mouseup": function($event) {
        return _vm.end()
      },
      "touchend": function($event) {
        $event.preventDefault();
        return _vm.end()
      }
    }
  }, [_c('a', {
    staticClass: "h-service m-size",
    on: {
      "click": function($event) {
        return _vm.toKefu()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_alert),
      expression: "show_alert"
    }],
    staticClass: "base-props-box"
  }, [_c('div', {
    staticClass: "props",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-a",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "middle-center"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("检测到您还未完善实名信息，为了更好的为您提供更多服务，请移步完善！")]), _vm._v(" "), _c('div', {
    staticClass: "div-btns clearfix"
  }, [_c('a', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toInfo()
      }
    }
  }, [_vm._v("前往完善")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_prop),
      expression: "show_prop"
    }],
    staticClass: "base-props-box"
  }, [_c('div', {
    staticClass: "props"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-a"
  }, [_c('div', {
    staticClass: "middle-center"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("此常住地无需与身份证地址相同，请选择您从事商业活动和日常生活所在地")]), _vm._v(" "), _c('div', {
    staticClass: "div-btns clearfix"
  }, [_c('a', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toAddress()
      }
    }
  }, [_vm._v("前往设置")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_area_prop),
      expression: "show_area_prop"
    }],
    staticClass: "base-props-box"
  }, [_c('div', {
    staticClass: "props",
    staticStyle: {
      "opacity": "0.8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-a"
  }, [_c('div', {
    staticClass: "middle-center"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("因系统完善，需完善您的所属区域，请选择您的所属区域")]), _vm._v(" "), _c('div', {
    staticClass: "div-btns clearfix"
  }, [_c('a', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        _vm.toUrl('/citySelect'), _vm.show_area_prop = false
      }
    }
  }, [_vm._v("选择")])])])])]), _vm._v(" "), (_vm.couponLists.length > 0) ? _c('div', {
    staticClass: "coupon"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "cou-box"
  }, [_vm._l((_vm.couponLists), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "coupon-item"
    }, [_c('div', {
      staticClass: "item-left"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("toFixedPrice")(item.amount)) + "元")]), _vm._v(" "), _c('span', [_vm._v("优惠券")])]), _vm._v(" "), _c('div', {
      staticClass: "item-right"
    }, [_c('span', [_vm._v(_vm._s(item.title))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "coupon-btn",
    on: {
      "click": function($event) {
        return _vm.getCoupon()
      }
    }
  })])], 2)]) : _vm._e(), _vm._v(" "), _c('popup', {
    staticClass: "augActivity",
    attrs: {
      "position": "center"
    },
    model: {
      value: (_vm.showAugActivity),
      callback: function($$v) {
        _vm.showAugActivity = $$v
      },
      expression: "showAugActivity"
    }
  }, [(_vm.showReplenishment) ? _c('div', {
    staticClass: "cont replenishment"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("images/aug_activity/tc01.png"),
      "alt": "tc01"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goPath('/distribution/stock/list', {
          stock_status: 1
        })
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showUnusedVoucher) ? _c('div', {
    staticClass: "cont unused_voucher"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("images/aug_activity/tc03.png"),
      "alt": "tc03"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("toFixedPrice")(_vm.voucherAmount)) + "元")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goPath('/distribution/coupon/exchange')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("setTimeTran")(_vm.voucherStartAt, 'n月j日')) + " - " + _vm._s(_vm._f("setTimeTran")(_vm.voucherEndAt, 'n月j日')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "close",
    class: {
      'mt0': _vm.showUnusedVoucher
    },
    on: {
      "click": function($event) {
        _vm.showAugActivity = false
      }
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("悦小妖商城")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22aaa510!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1857
// module chunks = 215